import React , {useEffect} from 'react'
import { connect } from "react-redux";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import LoaderComponent from "../components/LoaderComponent";
import { getChangeLogFilesLoading,getChangeLogFileData,getChangeLogTypeList,getChangeLogSubTypeList} from "../selector/selectors";
import { loadChangeLogs,loadChangeLogType,loadChangeLogSubType } from "../api/changelogapi";
import Grid from '@mui/material/Grid';
import SearchBoxComponent from "../components/SearchBoxComponent";
import SearchByComponent from "../components/SearchByComponent";
import ChangeLogTable from '../components/ChangeLogTable';
import DatePickerComponent from '../components/DatePickerComponent';
import { useDispatch } from "react-redux";
import ChangeLogTypeFilter from '../components/ChangeLogTypeFilter';
import ChangeLogSubTypeFilter from '../components/ChangeLogSubTypeFilter';


const ChangeLogs = ({
    isLoading,
    startLoadingChangeLogFiles,
    changeLogFilesList,
    changeLogTypeList,
    changeLogSubTypeList
}) => {
    const dispatch = useDispatch();
    const [tabValue, setTabValue] = React.useState('1');
    const [radioButtonValue, setRadioButtonValue] = React.useState('0');
    const [searchLabel, setSearchLabel] = React.useState('Genset Serial Number');
    const [searchValue, setSearchValue] = React.useState('');
    const [isFilterDisabled, setIsFilterDisabled] = React.useState(true);
    const [changeLogTypeVal, setChangeLogTypeVal] = React.useState('');
    const [changeLogSubTypeVal, setChangeLogSubTypeVal] = React.useState('');
    const [showSubFilterGrid, setShowSubFilterGrid] = React.useState(false);
    const [minToDate, setMinToDate] = React.useState(new Date());
    const [maxFromDate, setMaxFromDate] = React.useState(new Date());
    const [fromDate, setFromDate] = React.useState('');
    const [toDate, setToDate] = React.useState('');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    useEffect(() => {
        dispatch(loadChangeLogType());
        startLoadingChangeLogFiles('',radioButtonValue);
        // eslint-disable-next-line
    }, [startLoadingChangeLogFiles]);
    
    const handleChange = (event, val) => {
        setTabValue(val);
    };

    const handleRadioButtonChange = (event) => {
        if(event.target.value === '1'){
            setSearchLabel('Controller Serial Number');
        } else if(event.target.value === '2'){
            setSearchLabel('Username (Email)');
        } else {
            setSearchLabel('Genset Serial Number');
        }
        setRadioButtonValue(event.target.value);
        startLoadingChangeLogFiles(searchValue,event.target.value,changeLogTypeVal,changeLogSubTypeVal,fromDate,toDate,page,rowsPerPage);   
    };

    const handleSearialChangeTextValue = (event) => {
        if(event.target.value){
            setIsFilterDisabled(false)
        } else {
            setChangeLogTypeVal('')
            setChangeLogSubTypeVal('')
            setShowSubFilterGrid(false);
            setIsFilterDisabled(true) 
            setFromDate('')
            setToDate('')
        }
        setSearchValue(event.target.value);
        startLoadingChangeLogFiles(event.target.value,radioButtonValue,changeLogTypeVal,changeLogSubTypeVal,fromDate,toDate,page,rowsPerPage);    
    };


    const onClickChangeList=(typeId)=>{  
        setChangeLogTypeVal(typeId); 
        if(searchValue){
            setChangeLogSubTypeVal('');
            setShowSubFilterGrid(true);
            setPage(0);
            dispatch(loadChangeLogSubType(typeId));
            startLoadingChangeLogFiles(searchValue,radioButtonValue,typeId,'',fromDate,toDate,0,rowsPerPage); 
        }
    }

    const onClickSubTypeList = (subTypeId) => {
        setChangeLogSubTypeVal(subTypeId);
        if(searchValue){
            setPage(0);
            startLoadingChangeLogFiles(searchValue,radioButtonValue,changeLogTypeVal,subTypeId,fromDate,toDate,0,rowsPerPage); 
        }
    } 

    const handleFromDate = (fromDateParam) => {
        setMinToDate(fromDateParam);
        setFromDate(fromDateParam);
        if(fromDateParam && toDate){
            setPage(0);
            startLoadingChangeLogFiles(searchValue,radioButtonValue,changeLogTypeVal,changeLogSubTypeVal,fromDateParam,toDate,0,rowsPerPage);
        }
    }

    const handleToDate = (toDateParam) => {
        setMaxFromDate(toDateParam);
        setToDate(toDateParam);
        if(fromDate && toDateParam){
            setPage(0);
            startLoadingChangeLogFiles(searchValue,radioButtonValue,changeLogTypeVal,changeLogSubTypeVal,fromDate,toDateParam,0,rowsPerPage);
        }
    }

    const handleChangePage = (event, pageVal) => {
        setPage(pageVal);
        startLoadingChangeLogFiles(searchValue,radioButtonValue,changeLogTypeVal,changeLogSubTypeVal,fromDate,toDate,pageVal,rowsPerPage);
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
        startLoadingChangeLogFiles(searchValue,radioButtonValue,changeLogTypeVal,changeLogSubTypeVal,fromDate,toDate,0,event.target.value);
    }

 
    return (
        <Box sx={{ flexGrow: 1 }} >
            { isLoading ?  <LoaderComponent />: <></>}
            <Grid container >
                <TabContext  value={tabValue}>
                    <Grid item xs={12} md={12} lg={12} >
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange}  aria-label="">
                            <Tab label="Change Logs" value="1" />
                            </TabList>
                        </Box>
                        <TabPanel value="1" sx={{p:0,pt:2}}>
                            <Grid container sx={{paddingBottom:1}}>
                                <Grid item xs={12} sm={6} md={3.5} lg={3} xl={3}>
                                    <SearchByComponent 
                                        value={radioButtonValue}    
                                        handleRadioButtonChange={handleRadioButtonChange}
                                        isChangeLog={true}
                                    />  
                                </Grid>
                                <Grid item xs={12} sm={6} md={3} lg={3} xl={3} sx={{pr:3}}>
                                    <SearchBoxComponent 
                                        value={searchValue}
                                        handleChangeTextValue = {handleSearialChangeTextValue}
                                        label={searchLabel}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={5} md={2.5} lg={3} xl={3} className='fromDatePicker'>
                                    <DatePickerComponent value={fromDate} minDate={new Date('2023/01/01')} handleChange={handleFromDate}  isFilterDisabled={isFilterDisabled}  label="From Date" maxDate={maxFromDate} />
                                </Grid>    
                                <Grid item xs={12} sm={5} md={2.5} lg={3} xl={3} className='toDatePicker'>
                                    <DatePickerComponent value={toDate} minDate={minToDate} handleChange={handleToDate} isFilterDisabled={isFilterDisabled} label="To Date" maxDate={new Date()} />
                                </Grid>  
                            </Grid>
                            <Grid container>
                                <ChangeLogTypeFilter isFilterDisabled={isFilterDisabled} list={changeLogTypeList} onClickChangeList={onClickChangeList} /> 
                            </Grid>
                            {showSubFilterGrid && 
                                <Grid container>
                                    <ChangeLogSubTypeFilter isFilterDisabled={isFilterDisabled} list={changeLogSubTypeList} onClickSubTypeList={onClickSubTypeList} /> 
                                </Grid>
                            }
                            <ChangeLogTable page={page} rowsPerPage={rowsPerPage} handleChangeRowsPerPage={handleChangeRowsPerPage} handleChangePage={handleChangePage} changeLogsData={changeLogFilesList?.data} />
                        </TabPanel>
                    </Grid>
                </TabContext>
            </Grid>    
        </Box>
      );
}

const mapStateToProps = (state) => ({
    isLoading: getChangeLogFilesLoading(state),   
    changeLogFilesList: getChangeLogFileData(state),
    changeLogTypeList: getChangeLogTypeList(state),
    changeLogSubTypeList: getChangeLogSubTypeList(state),
  });
  
  const mapDispatchToProps = (dispatch) => ({
    startLoadingChangeLogFiles: (data,searchBy,changeLogTypeVal,changeLogSubTypeVal,fromDate,toDate,page,rowsPerPage)  => dispatch(loadChangeLogs(data,searchBy,changeLogTypeVal,changeLogSubTypeVal,fromDate,toDate,page,rowsPerPage)),
  });
  
export default connect(mapStateToProps, mapDispatchToProps)(ChangeLogs);
